<template>
    <div dir="ltr" class="tw-flex tw-items-center tw-gap-2">

        <!-- Logo image (branding upload, or the bundled brand asset) -->
        <img v-if="logoUrl" :src="logoUrl" class="tw-h-10 tw-w-auto tw-max-w-[170px] tw-object-contain" alt="logo" />

        <!-- Fallback icon + wordmark when no logo is available -->
        <template v-else>
            <div
                class="tw-w-[40px] tw-text-xl tw-font-bold tw-text-white tw-flex tw-items-center tw-justify-center tw-h-[40px] tw-bg-primary-500 tw-rounded-lg tw-border-4 tw-border-primary-300">
                <icon class="tw-text-2xl" icon="solar:box-line-duotone" />
            </div>
            <div class="tw-text-lg tw-font-black tw-tracking-wide tw-flex tw-items-center"
                :class="dark ? 'tw-text-white' : 'tw-text-gray-700'">
                <span v-if="name" class="tw-truncate tw-max-w-[160px]">{{ name }}</span>
                <template v-else>
                    <span class="tw-text-primary-500">Dash</span>
                    <span>board</span>
                </template>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useSettingsStore, useAuthStore } from '@/stores';

const props = defineProps({
    dark: { type: Boolean, default: false },
});

const settings = useSettingsStore();
const auth = useAuthStore();

// Bundled brand assets: white logo for dark surfaces, dark logo for light surfaces.
// Used across admin + client dashboards and the login pages.
const logoUrl = computed(() =>
    props.dark ? '/assets/images/logo-for-dark.png' : '/assets/images/logo-for-white.png');

const isClient = computed(() => auth.user?.role === 'client');

const name = computed(() => {
    const b = settings.branding || {};
    return (isClient.value ? (b.portal_name || b.business_name) : b.business_name) || 'HTV Shop';
});
</script>
